export const EVENT_NAME = 'GOS_MESSAGES';

export const EVENT_TYPES = {
  GAME_STATE_CHANGED: 'gameStateChanged',
  OPEN_LOGIN_FORM: 'openLoginForm',
  CHANGE_CATEGORY: 'changeCategory',
  NAVIGATE_TO_CATEGORY: "navigate/category",
  CASINO_TOURNAMENT_MODULE_TOUR_FINISHED: "casinoTournamentModuleTourFinished",
  SUCCESSFULL_REGISTRATION: "successfullRegistration",
  SUCCESSFULL_UNREGISTRATION: "successfullUnregistration",
  BALANCE_UPDATE: "balanceUpdate",
  SPIN_AND_GO_STARTED: "spinAndGoStarted",
  RESUME_TOURNAMENT: "resumeTournament",
};